import * as React from 'react';
import { translate } from 'components/translate-hoc';

import { getModeClass } from 'utils/css';
import { ICommonFieldProps } from './fields.types';

export class StringField extends React.Component<ICommonFieldProps> {
    public render(): JSX.Element {
        const {
            shouldInheritStyles,
            meta,
            input,
            translatePrefix,
            dangerouslyTranslateWithHTML: translateKey
        } = this.props;

        const className = getModeClass('sitegen-string-field', shouldInheritStyles);
        const labelText = translateKey(this.getLabelKey());
        const isWarning = meta.error && meta.submitFailed;
        const errorMessage = isWarning
            ? translateKey(`${translatePrefix}${meta.error.message}`, meta.error.data)
            : '';

        return (
            <div className={className}>
                <div className={`${className}__label`}>{labelText}</div>
                <div className={`${className}__container`}>
                    <input
                        {...input}
                        type="text"
                        className={`${className}__input`}
                    />
                    <div className={`${className}__error`}>{errorMessage}</div>
                </div>
            </div>
        );
    }

    private getLabelKey(): string {
        const { input, translatePrefix } = this.props;
        return `${translatePrefix}${input.name}`;
    }
}

export default translate()(StringField);
